import { DateTime } from 'luxon';

export const formatDate = (date: DateTime, format = 'MMMM d, yyyy'): string => {
  return date.toFormat(format);
};

export const isPastDate = (date: DateTime): boolean => {
  return date < DateTime.now();
};
